import { Button, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';

interface NoFilterResultsProps {
	filterType: string;
	resetFilters?: () => void;
}
export const NoFilterResults = ({ filterType, resetFilters }: NoFilterResultsProps) => {
	return (
		<Stack align="center" justify="center" mt="xl" px="sm">
			<ThemeIcon size={60} radius={60} color="" variant="light">
				<IconFilter size={32} />
			</ThemeIcon>
			<Text fw="bold">No results to display</Text>
			<Text style={{ textAlign: 'center' }}>There are no {filterType} that match the selected filters.</Text>
			<Button variant="light" radius="md" onClick={() => resetFilters && resetFilters()}>See all {filterType}</Button>
		</Stack>
	);
};
